import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';

import ChannelsSlider from '../../components/channels/channels-slider';
import { getAccessToken } from '../../../features/auth/authSlice';

const ChannelSliderLazyContainer = ({ selector, getContentAsync, title }) => {
  const { i18n } = useTranslation();
  const content = useSelector(selector);
  const dispatch = useDispatch();
  const accessToken = useSelector(getAccessToken);
  const { ref, inView } = useInView({ triggerOnce: true });

  useEffect(() => {
    (async () => {
      try {
        if (!inView) return;
        unwrapResult(dispatch(getContentAsync()));
      } catch (e) {
        console.log(e);
      }
    })();
  }, [dispatch, getContentAsync, i18n.language, accessToken, inView]);

  const updateContent = async () => {
    return await unwrapResult(await dispatch(getContentAsync()));
  };

  return (
    <div ref={ref}>
      <ChannelsSlider updateFavoriteChannels={updateContent} channels={content} heading={title} />
    </div>
  );
};

export default ChannelSliderLazyContainer;

ChannelSliderLazyContainer.propTypes = {
  selector: PropTypes.func.isRequired,
  getContentAsync: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};
